import { withProps } from 'recompose'
import { getSpecsPropertyValue } from './helpers'
import { SPEED_RATING, THREAD_LIFE_WARRANTY } from '../../constants'
import SpecsTab from './SpecsTab'

export default withProps(({
  specifications = []
}) => ({
  threadLifeWarranty: getSpecsPropertyValue({ specifications, specificationName: THREAD_LIFE_WARRANTY }) || '',
  speedRating: getSpecsPropertyValue({ specifications, specificationName: SPEED_RATING })
}))(SpecsTab)
